import React, { createContext, useContext, useState } from "react";
import { PasswordContextProps, PasswordProps } from "models/resetPassword";
import { ValidationObj } from "components/NewPassInput";

const ResetPasswordContext = createContext({} as PasswordContextProps);

function ResetPasswordProvider({ children }) {
  const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(true);
  const [validation, setValidation] = useState<ValidationObj>({});
  const [isSame, setIsSame] = useState<boolean>(false);
  const [password, setPassword] = useState<PasswordProps>({
    newPass: '',
    confirmPass: '',
  });
  const [warningInputClass, setWarningInputClass] = useState<string>('');

  return (
    <ResetPasswordContext.Provider
      value={{
        isBtnDisabled,
        isSame,
        password,
        validation,
        warningInputClass,
        setIsBtnDisabled,
        setIsSame,
        setPassword,
        setValidation,
        setWarningInputClass,
      }}
    >
      {children}
    </ResetPasswordContext.Provider>
  )
}

function useResetPasswordContext() {
  return useContext(ResetPasswordContext)
}

export { useResetPasswordContext, ResetPasswordProvider };